import { AskSynclyPage } from '@/features/ask-syncly/page/ask-syncly-page';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

export const Route = createFileRoute('/workspace/$workspaceId/ask-syncly/')({
  validateSearch: z.object({
    queryId: z.string().optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
  }),
  component: AskSynclyPage,
});
